import type {FC, PropsWithChildren} from "react";
import {createContext, useEffect, useState} from "react";

import type {AccordionTheme} from "../types/AccordionTheme";
import {Content, IProps as IContentProps} from "./Content";
import {Header, type IProps as IHeaderProps} from "./Header";

export interface IContext {
    expanded: boolean;
    onExpand: () => void;
    theme: AccordionTheme;
}

interface IComposition {
    Content: FC<PropsWithChildren<IContentProps>>;
    Header: FC<PropsWithChildren<IHeaderProps>>;
}

export const AccordionContext = createContext<IContext | undefined>(undefined);

interface IProps {
    className?: string;
    id?: string;
    initiallyExpanded?: boolean;
    onChange?: (expanded: boolean) => void;
    theme?: AccordionTheme;
}

export const Accordion: FC<PropsWithChildren<IProps>> & IComposition = (props) => {
    const {initiallyExpanded = false, theme = "white"} = props;

    const [expanded, setExpanded] = useState(initiallyExpanded);

    useEffect(() => {
        props.onChange?.(expanded);
    }, [expanded]);

    return (
        <AccordionContext.Provider value={{expanded, onExpand: () => setExpanded((prevState) => !prevState), theme}}>
            <div className={props.className} id={props.id}>
                {props.children}
            </div>
        </AccordionContext.Provider>
    );
};

Accordion.Content = Content;
Accordion.Header = Header;
import type {FC, PropsWithChildren} from "react";
import {createContext, useEffect, useState} from "react";

import type {AccordionTheme} from "../types/AccordionTheme";
import {Content, IProps as IContentProps} from "./Content";
import {Header, type IProps as IHeaderProps} from "./Header";

export interface IContext {
    expanded: boolean;
    onExpand: () => void;
    theme: AccordionTheme;
}

interface IComposition {
    Content: FC<PropsWithChildren<IContentProps>>;
    Header: FC<PropsWithChildren<IHeaderProps>>;
}

export const AccordionContext = createContext<IContext | undefined>(undefined);

interface IProps {
    className?: string;
    id?: string;
    initiallyExpanded?: boolean;
    onChange?: (expanded: boolean) => void;
    theme?: AccordionTheme;
}

export const Accordion: FC<PropsWithChildren<IProps>> & IComposition = (props) => {
    const {initiallyExpanded = false, theme = "white"} = props;

    const [expanded, setExpanded] = useState(initiallyExpanded);

    useEffect(() => {
        props.onChange?.(expanded);
    }, [expanded]);

    return (
        <AccordionContext.Provider value={{expanded, onExpand: () => setExpanded((prevState) => !prevState), theme}}>
            <div className={props.className} id={props.id}>
                {props.children}
            </div>
        </AccordionContext.Provider>
    );
};

Accordion.Content = Content;
Accordion.Header = Header;
